import { apiRequest, ycApiRequest } from '../axios/httpServiceHandler';
const BASE_URL = '/api'; // web网关
const ENTERPRISE = 'enterprise-platform'; // 底座企业服务
const BASE_SYSTEM = 'basic-system';
const BASE_INTEGRATION = 'basic-integration';

/**
 * 根据code获取accessToken
 * @returns {*}
 */
export const getToken = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-mt/auth/getTokenByCode`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: true,
    }
  );
};
/**
 * 根据accessToken获取用户信息
 * @returns {*}
 */
export const getUserInfoByToken = params => {
  return apiRequest(
    {
      url: '/api/basic-user/info',
      method: 'get',
      params,
    },
    {
      showLoading: true,
      showErrorToast: true,
    }
  );
};
/**
 * 刷新token
 * @returns {*}
 */
export const refreshIocBasicToken = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/${ENTERPRISE}/auth/refreshToken`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: true,
    }
  );
};

// 获取项目列表 ——new
export const getProjects = () => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-mt/project/appProjectList`,
      method: 'get',
      params: {
        current: 1,
        size: 999,
      },
    },
    {
      isNeedProjectCode: false,
      showLoading: true,
      showErrorToast: false,
    }
  );
};
export const getAllProjects = (params={}) => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-mt/project/companyProjectList`,
      method: 'get',
      params: {
        current: 1,
        size: 999,
        ...params
      },
    },
    {
      isNeedProjectCode: false,
      showLoading: true,
      showErrorToast: false,
    }
  );
};

// 获取用户认证的公司列表
export const getUserCompany = (params,needProject=true) => {
  return apiRequest(
    {
      url: `${BASE_URL}/${ENTERPRISE}/companyExt/pageByAuth`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: false,
      isNeedProjectCode: needProject,
    }
  );
};


// 获取用户已认证、待认证的公司列表
export const getAllUserCompany = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-mt/employee/auth/page`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: false,
      isNeedProjectCode: false,
    }
  );
};
// 获取我的审核列表
export const getMyAuths = params =>{
  return apiRequest(
    {
      url: `${BASE_URL}/residential-mt/employee/auth/pageWeb`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: false,
    }
  );
}


// 获取用户有通行权限的企业列表
export const getUserEntranceGuardCompany = params => {
  return apiRequest(
    {
      url: `/api/enterprise-app/guestRequest/getCompanyAddressByPhone`,
      method: 'get',
      params,
    },
    {
      showLoading: true,
      showErrorToast: false,
    }
  );
};

// 获取用户有通行权限的企业地址
export const getUserEntranceGuardAddress = params => {
  return apiRequest(
    {
      url: `/api/enterprise-app/useropen/getManufacturerListByCompanyId`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: false,
    }
  );
};

// 获取公司地址
export const getCompanyAddress = params => {
  return apiRequest(
    {
      url: `/api/residential-mt/client/space/page`,
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: false,
    }
  );
};

// 获取项目信息
export const getProjectDetail = params => {
  return apiRequest(
    {
      url: `/api/enterprise-platform/project/getByProjectCode`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  );
};

/**
 * 云城-根据code获取accessToken
 * @returns {*}
 */
export const getYcToken = params => {
  return ycApiRequest(
    {
      url: 'uaa/sns/oauth2/access_token',
      method: 'post',
      data: params,
    },
    {
      showLoading: true,
      showErrorToast: true,
    }
  );
};
/**
 * 云城-根据accessToken获取用户信息
 * @returns {*}
 */
export const getYcUserInfo = params => {
  return ycApiRequest(
    {
      url: 'userservice/userCenter/queryUserInfo',
      method: 'get',
      params,
    },
    {
      showLoading: true,
      showErrorToast: true,
    }
  );
};

// 文件上传
export const uploadFile = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/file/upload`,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60 * 1000,
    },
    {
      showLoading: true,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};
// 图片上传
export const uploadImgFile = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/file/uploadPic`,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60 * 1000,
    },
    {
      showLoading: true,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};
// 获取文件url
export const getFileUrl = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/file/getUrl`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: false,
      isNeedProjectCode: false,
    }
  );
};
// 批量获取文件url
export const getFileUrls = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/file/getUrls`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: false,
      isNeedProjectCode: false,
    }
  );
};

// 用户的子级菜单 (只返回一个层级)
export const getMenuChildren = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/${BASE_SYSTEM}/menu/user/one/level/children`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

// 用户角色对应的树形结构-不包含室内空间
export const getSpaceRoleTree = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/${BASE_INTEGRATION}/space/user/role/menu/exclude/room/tree`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

// 获取参数管理
export const getDetail = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/${BASE_SYSTEM}/param/detailList`,
      method: 'get',
      params,
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};
// 获取参数管理-未登录
export const getDetailAll = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/param/no-permit/getParamList`,
      method: 'post',
      data: params,
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

// 获取jssdk配置
export const getJssdkConfig = params => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-oauth/oauth/wechat/getJssdk`,
      method: 'post',
      data: params,
      headers: {
        Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
      },
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

// 获取文件资源配置地址

export const getDomain = () => {
  return apiRequest(
    {
      url: `${BASE_URL}/residential-system/miniIo/domain`,
      method: 'get',
      params:{},
    },
    {
      showLoading: false,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

export const cancelAuth = (params) => {
  return apiRequest(
    {
      url: `/api/residential-mt/employee/auth/removeAuthForApp`,
      method: 'get',
      params
    },
    {
      showLoading: true,
      showErrorToast: true,
      isNeedProjectCode: false,
    }
  );
};

/**
 * 根据子服务id获取子服务配置的模板
 */
export const getServiceTempl =async(params={})=>{ 
  return apiRequest(
    {
      url: `/api/residential-mt/spaceService/v2/getWechatTemplateId`,
      method: 'get',
      params
    },
    {
      showLoading: false,
      showErrorToast: false,
      isNeedProjectCode: false,
    }
  );
  
}
// 获取数据字典配置的枚举
export const getDic = async(params={})=>{ 
  return apiRequest(
    {
      url: `/api/residential-system/dict/dictionary`,
      method: 'get',
      params    
    },
    {
      showLoading: false,   
      showErrorToast: false,
      isNeedProjectCode: false,
    }
  );
}
